import * as React from "react";
const SvgFiRrSortSizeUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sort-size-up_svg__a)">
      <path
        fill="#062147"
        d="M21 15h-2c-1.65 0-3 1.35-3 3v2c0 1.65 1.35 3 3 3h2c1.65 0 3-1.35 3-3v-2c0-1.65-1.35-3-3-3m1 5c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h2c.55 0 1 .45 1 1zM21 1h-4c-1.65 0-3 1.35-3 3v4c0 1.65 1.35 3 3 3h4c1.65 0 3-1.35 3-3V4c0-1.65-1.35-3-3-3m1 7c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1zM11.69 4.28A.996.996 0 0 1 11.01 6c-.25 0-.5-.09-.69-.28L7.01 2.57V23c0 .55-.45 1-1 1s-1-.45-1-1V2.57L1.69 5.72c-.4.38-1.03.37-1.41-.03a.987.987 0 0 1 .04-1.41L3.9.86C5.05-.29 6.95-.29 8.12.88z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sort-size-up_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSortSizeUp;
